import { createColor } from '@manakin/theme/lib/color';

const black = createColor('#000');

export default black;
